import { Component, Input, OnInit } from '@angular/core';
import { User } from '@app/core/models/user/user.model';
import { CpfPipe } from '@app/shared/pipes/cpf.pipe';

@Component({
  selector: 'app-current-user-box',
  templateUrl: './current-user-box.component.html',
  styleUrls: ['./current-user-box.component.scss'],
})
export class CurrentUserBoxComponent implements OnInit {
  @Input() currentUser: User;

  @Input() variant = 'primary';

  cpfMask: string;

  constructor(private cpfPipe: CpfPipe) {}

  get currentUserFullNameInitials() {
    if (this.currentUser) {
      const initials = this.currentUser.fullName.match(/\b\w/g) || [];

      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    }
  }

  ngOnInit() {
    this.cpfMask = this.cpfPipe
      .transform(this.currentUser.CPF)
      .replace(/.\d+.\d+-/, '.XXX.XXX-');
  }
}
